



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { FormLabel } from '@/models/Form';
import { BModal } from 'bootstrap-vue';

@Component({
    name: 'ModalFormLabelRemove',
    components: {
        'b-modal': BModal,
    },
})
export default class ModalFormLabelRemove extends Vue {
    updating = false;
    error: string = '';

    @Prop() private label!: FormLabel;

    async remove() {
        this.updating = true;

        try {
            await this.$store.dispatch('formLabels/delete', this.label);
        } catch (error) {
            this.error = error;
        } finally {
            this.updating = false;
        }
    }
}
